module.exports = __webpack_public_path__ + "img/img16.2bc26f5b.svg";